if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (document.querySelectorAll(".selected-product-item .item-check-btn input:checked").length != 0) {
          var addItemID = [];
          var properties_list = [];
          var accessList = document.querySelectorAll(
            ".selected-product-item .item-check-btn input:checked"
          );

          accessList.forEach((list) => {
            var checkedVal = list.value;
            var data_item = list.getAttribute('data-item');
            var checked_data = {
              id: parseInt(checkedVal),
              quantity: 1,
              properties: {
                "data-item": data_item
              }
            };
            addItemID.push(checked_data);
          });

          var mainProVariID = this.form
            .querySelector(".product-variant-id")
            .getAttribute("value");
          var mainProQty = this.form
            .closest(".qty-and-atc-btn")
            .querySelector(".quantity__input").value;
          
           accessList.forEach((list) => {
            var checkedVal = parseInt(list.value);
            properties_list.push({"item":checkedVal});
           });
          
           mainProVariID = parseInt(mainProVariID);
           properties_list.push({"item":mainProVariID});
          
          var checked_data2 = {
            id: mainProVariID,
            quantity: parseInt(mainProQty),
            properties: {
              properties_list
            }
          };
          addItemID.push(checked_data2);

          let __formData = { items: addItemID };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(__formData),
          })
            .then((response) => response.json())
            .then((response) => {
              
              this.cart.renderContentsMulti(response);
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
